/* FBD Outlet — site behaviour. ES5-compatible (no arrow functions, optional chaining, etc.)
   Works in the static preview (mock cart) and in Shopify (AJAX cart) — the theme sets data-shopify="1" on <body>. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var isShopify = body.getAttribute('data-shopify') === '1';
  root.className += ' js';

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn, false); }
  function closest(el, sel) {
    if (el && el.closest) return el.closest(sel);
    var m = el && (el.matches || el.msMatchesSelector || el.webkitMatchesSelector);
    if (!m) return null;
    while (el && el.nodeType === 1) { if (m.call(el, sel)) return el; el = el.parentNode; }
    return null;
  }
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function storage(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key); else window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  /* ================= Instrument helpers =================
     Declared above every module on purpose (the v5 hoisting trap): anything below may use
     them at load time. None of them reads wantsMotion, which is declared further down. */
  function prefersReduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function nextFrame(fn) {
    if (window.requestAnimationFrame) return window.requestAnimationFrame(fn);
    return window.setTimeout(function () { fn(); }, 16);
  }
  function clock() { return (window.performance && window.performance.now) ? window.performance.now() : new Date().getTime(); }
  var passiveOpt = false;
  try {
    window.addEventListener('fbd-probe', null, Object.defineProperty({}, 'passive', { get: function () { passiveOpt = { passive: true }; return true; } }));
  } catch (e) { passiveOpt = false; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  /* Tab and Shift+Tab wrap inside an open dialog (the cart drawer, the phone menu) instead of
     walking out to the covered page (v8 polish) */
  function trapTab(box, e) {
    if (e.key !== 'Tab' || !box) return;
    var els = Array.prototype.slice.call(box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !el.hidden && (el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1], a = document.activeElement;
    var inside = box.contains(a);
    if (e.shiftKey && (a === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !inside)) { e.preventDefault(); first.focus(); }
  }

  /* Readout.roll: a figure settles from one whole number to another (ease-out cubic). fmt(v)
     returns the markup to write, so a counter can rebuild its own <em>. A new roll on the same
     element cancels the running one. Under reduced motion the final value is written at once.
     Prices never go through this: the correct price is always on screen. */
  var Readout = (function () {
    var seq = 0;
    function write(el, html) { if (el.innerHTML !== html) el.innerHTML = html; }
    function roll(el, from, to, fmt, ms, onFrame) {
      if (!el) return;
      var token = ++seq;
      el.setAttribute('data-roll', String(token));
      if (prefersReduced() || from === to || !(ms > 0)) {
        write(el, fmt(to));
        if (onFrame) onFrame(to, 1);
        return;
      }
      write(el, fmt(from));   /* the first frame shows where it comes from, never the authored end value */
      var t0 = null;
      function step() {
        if (el.getAttribute('data-roll') !== String(token)) return;   /* superseded */
        var t = clock();
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / ms);
        var v = p < 1 ? Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3))) : to;
        write(el, fmt(v));
        if (onFrame) onFrame(v, p);
        if (p < 1) nextFrame(step);
      }
      nextFrame(step);
    }
    return { roll: roll };
  })();

  /* Scroll: one rAF-throttled scroll listener for every module that reads position. Handlers
     are named, so re-registering (after a Theme Editor section reload) replaces rather than
     stacks. Each receives pageYOffset. */
  var Scroll = (function () {
    var subs = [], ticking = false, bound = false;
    function run() {
      ticking = false;
      var y = window.pageYOffset || doc.documentElement.scrollTop || 0;
      for (var i = 0; i < subs.length; i++) {
        try { subs[i].fn(y); } catch (err) { (function (e) { window.setTimeout(function () { throw e; }, 0); })(err); }
      }
    }
    function request() { if (!ticking) { ticking = true; nextFrame(run); } }
    function on_(name, fn) {
      for (var i = 0; i < subs.length; i++) if (subs[i].name === name) { subs[i].fn = fn; return; }
      subs.push({ name: name, fn: fn });
      if (!bound) {
        bound = true;
        window.addEventListener('scroll', request, passiveOpt);
        window.addEventListener('resize', request, false);
      }
    }
    return { on: on_, request: request };
  })();

  /* FormState: the one form choice (capsules or liquid) the whole page follows (fbd.css section 53).
     The opener, the formula panels, the deck and the compare switch each subscribe; whichever the
     visitor uses sets it, and src names who set it so a module does not answer its own change.
     Nothing moves on its own and nothing is remembered: a reload starts on capsules, the main buy. */
  var FormState = (function () {
    var cur = null, subs = [];
    return {
      get: function () { return cur || 'capsules'; },
      set: function (f, src) {
        if (f !== 'capsules' && f !== 'liquid') return;
        if (f === cur) return;
        cur = f;
        for (var i = 0; i < subs.length; i++) {
          try { subs[i](f, src); } catch (err) { (function (e) { window.setTimeout(function () { throw e; }, 0); })(err); }
        }
      },
      on: function (fn) { subs.push(fn); }
    };
  })();

  /* Arm: a press shows the corner brackets under the finger at once (fbd.css section 47),
     before the click lands and the panel changes. */
  (function arm() {
    var SEL = '.oform, .deck__tab, .tl__stop, .rail__link, .segs__btn, .finder__cat, .fitem__sum';
    var armed = null, timer = 0;
    function disarm(el) { el.className = el.className.replace(/(^|\s)is-armed(?=\s|$)/g, ''); }
    function down(e) {
      var el = closest(e.target, SEL);
      if (!el) return;
      window.clearTimeout(timer);
      if (armed && armed !== el) disarm(armed);
      armed = el;
      if (!/(^|\s)is-armed(\s|$)/.test(el.className)) el.className += ' is-armed';
    }
    function up() {
      if (!armed) return;
      var el = armed;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { disarm(el); if (armed === el) armed = null; }, 220);
    }
    if (window.PointerEvent) {
      doc.addEventListener('pointerdown', down, passiveOpt);
      doc.addEventListener('pointerup', up, passiveOpt);
      doc.addEventListener('pointercancel', up, passiveOpt);
    } else {
      doc.addEventListener('touchstart', down, passiveOpt);
      doc.addEventListener('touchend', up, passiveOpt);
      doc.addEventListener('touchcancel', up, passiveOpt);
    }
  })();



  /* ---------- Theme toggle ---------- */
  (function theme() {
    var btns = $$('[data-theme-toggle]');
    if (!btns.length) return;
    function current() {
      var explicit = root.getAttribute('data-theme');
      if (explicit) return explicit;
      return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
    }
    function label(mode) {
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-label', mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      }
    }
    function apply(next) {
      root.setAttribute('data-theme', next);
      storage('fbd-theme', next);
      label(next);
    }
    for (var i = 0; i < btns.length; i++) {
      on(btns[i], 'click', function () { apply(current() === 'dark' ? 'light' : 'dark'); });
    }
    /* the markup says "Switch to dark mode"; a page that opens dark must say the opposite */
    label(current());
    var mm = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    if (mm && mm.addListener) mm.addListener(function () { if (!root.getAttribute('data-theme')) label(current()); });
  })();

  /* ---------- Header scroll state ---------- */
  (function header() {
    var h = $('[data-header]');
    if (!h) return;
    var state = null;
    function update(y) {
      var s = y > 8;
      if (s === state) return;
      state = s;
      h.className = h.className.replace(' is-scrolled', '') + (s ? ' is-scrolled' : '');
    }
    Scroll.on('header', update);
    update(window.pageYOffset);
  })();

  /* ---------- Mobile nav ---------- */
  (function mobileNav() {
    var nav = $('[data-mobile-nav]');
    var open = $('[data-menu-open]');
    var close = $('[data-menu-close]');
    if (!nav || !open) return;
    /* .menu-open: in Shopify the panel lives inside the sticky header section wrapper, whose
       stacking context (z-index 90) sits under the announcement bar (95). sections/header.liquid
       raises that wrapper to 100 while this class is on <body>, so the close button stays reachable. */
    function show() { nav.hidden = false; body.className += ' no-scroll menu-open'; open.setAttribute('aria-expanded', 'true'); if (close) close.focus(); }
    function hide() { nav.hidden = true; body.className = body.className.replace(' menu-open', '').replace(' no-scroll', ''); open.setAttribute('aria-expanded', 'false'); open.focus(); }
    on(open, 'click', show);
    on(close, 'click', hide);
    $$('a', nav).forEach(function (a) { on(a, 'click', hide); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) hide(); if (!nav.hidden) trapTab(nav, e); });
  })();

  /* ---------- Hero form switch: buttons, ghost word, product row and CTA ---------- */


  /* ---------- Formulas timeline ---------- */
  (function timeline() {
    var tl = $('[data-timeline]');
    if (!tl) return;
    var stops = $$('[data-stop]', tl);
    var panels = $$('[data-panel]', tl);
    function select(id, focus) {
      stops.forEach(function (s) {
        var active = s.getAttribute('data-stop') === id;
        s.setAttribute('aria-selected', active ? 'true' : 'false');
        s.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focus) s.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
    }
    stops.forEach(function (s, i) {
      on(s, 'click', function () { select(s.getAttribute('data-stop'), false); });
      on(s, 'keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = stops[(i + 1) % stops.length];
        if (e.key === 'ArrowLeft') n = stops[(i - 1 + stops.length) % stops.length];
        if (e.key === 'Home') n = stops[0];
        if (e.key === 'End') n = stops[stops.length - 1];
        if (n) { e.preventDefault(); select(n.getAttribute('data-stop'), true); }
      });
    });
    var initial = $('[data-stop][aria-selected="true"]', tl) || stops[0];
    if (initial) select(initial.getAttribute('data-stop'), false);
    /* the chosen form leads in every panel: its bottle at full strength, its dose line first */
    FormState.on(function (f) { tl.setAttribute('data-form', f); });
  })();

  /* ---------- Product gallery ---------- */
  (function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    var mains = $$('[data-gallery-main]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        var id = t.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        mains.forEach(function (m) { m.hidden = m.getAttribute('data-gallery-main') !== id; });
      });
    });
  })();

  /* ---------- Quantity steppers ---------- */
  on(doc, 'click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!b) return;
    var wrap = b.parentNode;
    var input = $('input', wrap);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += b.getAttribute('data-qty') === '+' ? 1 : -1;
    if (v < 1) v = 1;
    if (v > 99) v = 99;
    input.value = v;
    var ev; try { ev = new Event('change', { bubbles: true }); } catch (err) { ev = doc.createEvent('Event'); ev.initEvent('change', true, true); }
    input.dispatchEvent(ev);
  });

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  (function stickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    /* shown once the page's own button has scrolled away above, and hidden again while the
       footer is on screen: the bar is fixed with no spacer, so at the end of the page it sat
       over the legal links and the designer credit */
    var foot = $('.footer');
    var passed = false, atFoot = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.target === anchor) passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        else atFoot = e.isIntersecting;
      }
      bar.className = bar.className.replace(' is-visible', '') + (passed && !atFoot ? ' is-visible' : '');
    }, { threshold: 0 });
    io.observe(anchor);
    if (foot) io.observe(foot);
  })();

  /* ---------- Toast ---------- */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.className = toastEl.className.replace(' is-visible', '') + ' is-visible';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.className = toastEl.className.replace(' is-visible', ''); }, 2600);
  }

  /* ---------- Cart (Shopify AJAX or preview mock) ---------- */
  var Cart = (function () {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-overlay]');
    var list = $('[data-cart-lines]');
    var empty = $('[data-cart-empty]');
    var foot = $('[data-cart-foot]');
    var totalEl = $('[data-cart-total]');
    var counts = $$('[data-cart-count]');
    var savedRow = $('[data-cart-saved]');
    var savedAmt = $('[data-cart-saved-amt]');
    var savedFill = savedRow ? $('.drawer__fill', savedRow) : null;
    var kit = $('[data-cart-kit]');
    var kitList = $('[data-cart-kit-list]');
    var lastFocus = null;

    /* The savings instrument (fbd.css section 52). meta.compare maps a variant id to its list price
       in cents; meta.companions are the three companions offered under "Complete the program".
       Shopify renders both in snippets/cart-drawer.liquid; the list prices of any add-to-cart form
       on the page are merged in, which is all the preview needs. A product with no list price above
       its price counts at its own price, so the saving is never overstated. */
    var meta = { compare: {}, companions: [] };
    (function readMeta() {
      var tag = $('[data-cart-meta]');
      if (tag) {
        try {
          var m = JSON.parse(tag.textContent || '{}');
          if (m && m.compare) meta.compare = m.compare;
          if (m && m.companions && m.companions.length) meta.companions = m.companions;
        } catch (e) { /* malformed: the drawer simply shows no saving */ }
      }
      $$('form[data-add-to-cart]').forEach(function (f) {
        var id = f.getAttribute('data-id') || ($('[name="id"]', f) || {}).value;
        var c = parseInt(f.getAttribute('data-compare'), 10);
        if (id && c > 0 && meta.compare[id] === undefined) meta.compare[id] = c;
      });
    })();
    function listPrice(it) {
      var c = parseInt(it.compare !== undefined && it.compare !== null ? it.compare : meta.compare[String(it.id)], 10);
      return c > it.price ? c : it.price;
    }

    /* -- transport -- */
    function request(method, url, data) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        if (data) xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
          var json = null;
          try { json = JSON.parse(xhr.responseText); } catch (e) { json = null; }
          if (xhr.status >= 200 && xhr.status < 300) resolve(json); else reject(json || { message: 'Request failed' });
        };
        xhr.onerror = function () { reject({ message: 'Network error' }); };
        xhr.send(data ? JSON.stringify(data) : null);
      });
    }

    var mock = {
      read: function () { try { return JSON.parse(storage('fbd-cart-demo') || '{"items":[]}'); } catch (e) { return { items: [] }; } },
      write: function (c) { storage('fbd-cart-demo', JSON.stringify(c)); return normalize(c); },
      add: function (items) {
        var c = mock.read();
        for (var n = 0; n < items.length; n++) {
          var item = items[n], found = null;
          for (var i = 0; i < c.items.length; i++) if (String(c.items[i].id) === String(item.id)) found = c.items[i];
          if (found) found.quantity += item.quantity; else c.items.push(item);
        }
        return Promise.resolve(mock.write(c));
      },
      change: function (id, qty) {
        var c = mock.read();
        c.items = c.items.filter(function (it) { if (it.id === id) { it.quantity = qty; } return it.quantity > 0; });
        return Promise.resolve(mock.write(c));
      },
      get: function () { return Promise.resolve(normalize(mock.read())); }
    };

    function normalize(c) {
      var items = (c.items || []).map(function (it) {
        return {
          id: it.id, key: it.key || it.id, title: it.product_title || it.title, variant: it.variant_title,
          quantity: it.quantity, price: it.original_price !== undefined ? it.original_price : it.price,
          compare: it.compare,
          line: it.final_line_price !== undefined ? it.final_line_price : (it.line_price !== undefined ? it.line_price : it.price * it.quantity),
          image: it.image, url: it.url
        };
      });
      var total = 0, count = 0;
      items.forEach(function (it) { total += it.line; count += it.quantity; });
      return { items: items, total: c.total_price !== undefined ? c.total_price : total, count: c.item_count !== undefined ? c.item_count : count, sections: c.sections || null };
    }

    var api = isShopify ? {
      add: function (items) {
        return request('POST', '/cart/add.js', { items: items.map(function (it) { return { id: it.id, quantity: it.quantity }; }) }).then(api.get);
      },
      /* sectionId: the cart page asks Shopify to render its own section in the same response */
      change: function (id, qty, sectionId) {
        var data = { id: id, quantity: qty };
        if (sectionId) { data.sections = [sectionId]; data.sections_url = window.location.pathname; }
        return request('POST', '/cart/change.js', data).then(normalize);
      },
      get: function () { return request('GET', '/cart.js').then(normalize); }
    } : mock;

    /* -- render -- */
    var shownSaved = 0, shownRatio = 1;
    function renderSavings(cart) {
      if (!savedRow && !kit) return;
      var listTotal = 0, inCart = {};
      cart.items.forEach(function (it) { listTotal += listPrice(it) * it.quantity; inCart[String(it.id)] = true; });
      var paid = cart.total, saved = listTotal - paid;
      if (savedRow) {
        if (saved > 0 && cart.items.length) {
          savedRow.hidden = false;
          var ratio = listTotal > 0 ? paid / listTotal : 1, r0 = shownRatio, s0 = shownSaved;
          /* the figure settles and the meter follows it in lockstep; scaleX, never width (v5) */
          Readout.roll(savedAmt, s0, saved, money, 320, function (v, p) {
            var k = saved === s0 ? 1 : (v - s0) / (saved - s0);
            if (p >= 1) k = 1;
            if (savedFill) savedFill.style.transform = 'scaleX(' + (r0 + (ratio - r0) * k).toFixed(4) + ')';
          });
          shownSaved = saved; shownRatio = ratio;
          var ends = $('.drawer__ends', savedRow);
          if (!ends) { ends = doc.createElement('span'); ends.className = 'drawer__ends'; savedRow.insertBefore(ends, savedRow.children[1] || null); }
          ends.innerHTML = '<span>You pay <b class="num">' + money(paid) + '</b></span><span>List <b class="num">' + money(listTotal) + '</b></span>';
        } else {
          savedRow.hidden = true;
          shownSaved = 0; shownRatio = 1;
        }
      }
      if (kit && kitList) {
        var rows = meta.companions.filter(function (c) { return c.available !== false && !inCart[String(c.id)]; }).slice(0, 3);
        kitList.innerHTML = '';
        rows.forEach(function (c) {
          var li = doc.createElement('li');
          li.className = 'kit';
          var was = c.compare > c.price ? ' <s class="was">' + money(c.compare) + '</s>' : '';
          li.innerHTML = '<span class="kit__name"></span><span class="kit__price num">+' + money(c.price) + was + '</span>' +
            '<button class="btn btn--ghost btn--sm" type="button" data-kit-add="' + String(c.id).replace(/"/g, '') + '">Add</button>';
          $('.kit__name', li).textContent = c.title;
          kitList.appendChild(li);
        });
        kit.hidden = !cart.items.length || !rows.length;
      }
    }

    /* which drawer control holds focus, described so it can be found again after the lines and kit
       rows are rebuilt (their buttons are replaced, which dropped focus to <body>) */
    function focusKey() {
      var a = doc.activeElement;
      if (!drawer || !a || !drawer.contains(a) || a === drawer) return null;
      var li = closest(a, '.line'), input = li ? $('[data-line-qty]', li) : null;
      if (input && a.getAttribute('data-qty')) return { line: input.getAttribute('data-line-qty'), sel: '[data-qty="' + a.getAttribute('data-qty') + '"]' };
      if (a.getAttribute('data-line-qty')) return { line: a.getAttribute('data-line-qty'), sel: '[data-line-qty]' };
      if (a.getAttribute('data-line-remove')) return { line: a.getAttribute('data-line-remove'), sel: '[data-line-remove]', gone: true };
      if (a.getAttribute('data-kit-add')) return { kit: true };
      return null;
    }
    function restoreFocus(k) {
      if (!k || !drawer || drawer.className.indexOf('is-open') < 0) return;
      var target = null;
      if (k.line) {
        var input = $('[data-line-qty="' + k.line.replace(/"/g, '') + '"]', drawer), li = input ? closest(input, '.line') : null;
        target = li ? $(k.sel, li) : null;
      }
      if (!target && k.kit) target = $('[data-kit-add]', drawer);
      if (!target) target = $('.line [data-line-remove]', drawer) || $('[data-cart-foot]:not([hidden]) .btn--primary', drawer) || $('[data-cart-empty] a', drawer) || $('[data-cart-close]', drawer);
      if (target && target.focus) target.focus();
    }
    function render(cart) {
      var fk = focusKey();
      counts.forEach(function (c) { c.textContent = cart.count; c.setAttribute('data-count', String(cart.count)); });
      renderSavings(cart);
      if (!list) { restoreFocus(fk); return; }
      list.innerHTML = '';
      var has = cart.items.length > 0;
      if (empty) empty.hidden = has;
      if (foot) foot.hidden = !has;
      if (totalEl) totalEl.textContent = money(cart.total);
      cart.items.forEach(function (it) {
        var li = doc.createElement('li');
        li.className = 'line';
        li.innerHTML =
          '<div class="line__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div>' +
            '<div class="line__title">' + it.title + '</div>' +
            (it.variant && it.variant !== 'Default Title' ? '<div class="small muted">' + it.variant + '</div>' : '') +
            '<div class="line__meta">' +
              '<div class="qty"><button class="qty__btn" type="button" data-qty="-" aria-label="Decrease quantity">&minus;</button>' +
              '<input class="qty__input" type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-line-qty="' + it.key + '">' +
              '<button class="qty__btn" type="button" data-qty="+" aria-label="Increase quantity">+</button></div>' +
              '<span class="price num">' + money(it.line) + '</span>' +
            '</div>' +
            '<button class="line__remove" type="button" data-line-remove="' + it.key + '">Remove</button>' +
          '</div>';
        list.appendChild(li);
      });
      restoreFocus(fk);
    }

    function open() {
      if (!drawer) return;
      lastFocus = doc.activeElement;
      drawer.className += ' is-open';
      if (overlay) overlay.className += ' is-open';
      drawer.setAttribute('aria-hidden', 'false');
      body.className += ' no-scroll';
      var c = $('[data-cart-close]', drawer); if (c) c.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.className = drawer.className.replace(' is-open', '');
      if (overlay) overlay.className = overlay.className.replace(' is-open', '');
      drawer.setAttribute('aria-hidden', 'true');
      body.className = body.className.replace(' no-scroll', '');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    on(overlay, 'click', close);
    $$('[data-cart-close]').forEach(function (b) { on(b, 'click', close); });
    $$('[data-cart-open]').forEach(function (b) { on(b, 'click', function (e) { if (drawer) { e.preventDefault(); api.get().then(render); open(); } }); });
    on(doc, 'keydown', function (e) {
      if (!drawer || drawer.className.indexOf('is-open') < 0) return;
      if (e.key === 'Escape') close(); else trapTab(drawer, e);
    });

    /* The cart page is rendered by the server, so render() cannot reach its line prices and
       subtotal: after a quantity change they stayed stale while the cart itself had changed.
       In Shopify the change request asks for the cart section's fresh markup (bundled section
       rendering) and swaps it in; with no markup back it reloads. The preview's mock cart has no
       server, so there the numbers are patched in place through [data-line-price] and
       [data-cart-subtotal]. Only the newest request may repaint, so fast clicks cannot land an
       older total over a newer one. */
    var pageSeq = 0;
    function refreshPage(page, cart, seq, key) {
      if (seq !== pageSeq) return;
      var id = page.getAttribute('data-cart-page');
      var html = cart.sections && id ? cart.sections[id] : null;
      if (html) {
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-cart-page]', tmp);
        if (fresh) {
          var act = doc.activeElement;
          var which = act && act.getAttribute ? act.getAttribute('data-qty') : null;
          page.innerHTML = fresh.innerHTML;
          var inp = which ? $('[data-line-qty="' + key + '"]', page) : null;
          var btn = inp ? $('[data-qty="' + which + '"]', inp.parentNode) : null;
          if (btn) btn.focus();
          return;
        }
      }
      if (isShopify) { window.location.reload(); return; }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[String(it.key)] = it; });
      $$('[data-line-price]', page).forEach(function (el) {
        var it = byKey[el.getAttribute('data-line-price')];
        if (it) { el.textContent = money(it.line); return; }
        var li = closest(el, '.line');
        if (li && li.parentNode) li.parentNode.removeChild(li);
      });
      var sub = $('[data-cart-subtotal]', page);
      if (sub) sub.textContent = money(cart.total);
    }
    on(doc, 'change', function (e) {
      var inp = e.target;
      if (!inp.getAttribute || !inp.getAttribute('data-line-qty')) return;
      var qty = parseInt(inp.value, 10); if (isNaN(qty) || qty < 0) qty = 0;
      var key = inp.getAttribute('data-line-qty');
      var page = closest(inp, '[data-cart-page]');
      var seq = page ? ++pageSeq : 0;
      api.change(key, qty, page ? page.getAttribute('data-cart-page') : '').then(function (cart) {
        render(cart);
        if (page) refreshPage(page, cart, seq, key);
      });
    });
    on(doc, 'click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-line-remove]') : null;
      if (!b) return;
      api.change(b.getAttribute('data-line-remove'), 0).then(render);
    });

    /* addItems: one or more lines into the cart, with the button's Adding / Added label, the count
       bump and the drawer opening as the confirmation. The add-to-cart forms and the drawer's
       "Complete the program" rows both come through here. */
    function addItems(items, btn, keepOpen) {
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding&hellip;'; }
        api.add(items).then(function (cart) {
          render(cart);
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.innerHTML = 'Added';
            btn.className += ' is-added';
            setTimeout(function () { btn.innerHTML = label; btn.className = btn.className.replace(' is-added', ''); }, 1400);
          }
          $$('[data-cart-count]').forEach(function (c) {
            c.className = c.className.replace(' is-bumped', '') + ' is-bumped';
            setTimeout(function () { c.className = c.className.replace(' is-bumped', ''); }, 500);
          });
          if (!keepOpen) open();   /* the drawer opening is the confirmation; a toast here sat over its Checkout button */
        }, function (err) {
          if (btn && btn.parentNode) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
          toast((err && (err.description || err.message)) || 'Could not add to cart');
        });
    }

    /* add-to-cart forms */
    $$('form[data-add-to-cart]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (!drawer) return; /* no drawer: let the form post to /cart/add normally */
        e.preventDefault();
        var idInput = $('[name="id"]', form);
        var qtyInput = $('[name="quantity"]', form);
        var compare = parseInt(form.getAttribute('data-compare'), 10);
        addItems([{
          id: idInput ? idInput.value : form.getAttribute('data-id'),
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1,
          title: form.getAttribute('data-title'),
          price: parseInt(form.getAttribute('data-price'), 10) || 0,
          compare: compare > 0 ? compare : null,
          image: form.getAttribute('data-image')
        }], $('[type="submit"]', form));
      });
    });

    /* "Complete the program": Add puts the companion in the cart; the meter and figures settle.
       On failure the row stays and Shopify's message is shown. */
    on(doc, 'click', function (e) {
      var b = closest(e.target, '[data-kit-add]');
      if (!b) return;
      var id = b.getAttribute('data-kit-add'), c = null;
      for (var i = 0; i < meta.companions.length; i++) if (String(meta.companions[i].id) === id) c = meta.companions[i];
      if (!c) return;
      addItems([{ id: c.id, quantity: 1, title: c.full || c.title, price: c.price, compare: c.compare, image: c.image }], b, true);
    });

    if (window.Promise) api.get().then(render, function () {});
    return { open: open, close: close, add: addItems, refresh: function () { if (window.Promise) api.get().then(render); } };
  })();

  /* ---------- Newsletter (preview only; Shopify uses the customer form) ---------- */
  (function newsletter() {
    var form = $('[data-newsletter-demo]');
    if (!form) return;
    on(form, 'submit', function (e) {
      e.preventDefault();
      var msg = $('[data-form-msg]', form);
      var email = $('input[type="email"]', form);
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { if (msg) { msg.textContent = 'Please enter a valid email address.'; msg.className = 'form-msg form-msg--error'; } return; }
      if (msg) { msg.textContent = 'You are on the list. Welcome.'; msg.className = 'form-msg'; }
      email.value = '';
    });
  })();


  /* ---------- Specimen lines (fbd.css section 49) ----------
     The lineup in each product band is labelled like a specimen. Everything drawn is a
     function of one number p (0 = retracted, 1 = fully drawn): a 1px scan at p of the width,
     each bottle's label as the scan passes its measured centre (data-c), the two halves of the
     rule and its caption. In the pinned stage frame() hands in the slide's position; anywhere
     else (phones, a disabled stage) a Scroll-bus reader derives p from the band's own live
     position while an IntersectionObserver says it is on screen. Under reduced motion nothing
     registers and the CSS resting state (fully drawn) stays. Declared above buildStage(),
     which calls it. */
  var Dim = (function () {
    var reduce = prefersReduced();
    var all = [], live = [], io = null;
    function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
    function state(d) {
      if (d._dim) return d._dim;
      var lis = $$('.dim__slots li', d);
      var st = { el: d, scan: $('.dim__scan', d), rule: $('.dim__rule', d), lines: $$('.dim__line', d), total: $('.dim__total', d),
                 lis: lis, cs: [], p: -1, W: 0, ranges: null };
      for (var i = 0; i < lis.length; i++) st.cs.push(parseFloat(lis[i].getAttribute('data-c')) || 0);
      d._dim = st;
      return st;
    }
    function measure(st) {
      st.W = st.el.offsetWidth || 1;
      /* the times show only where they fit their slot: the narrowest gap between two measured
         centres, less a little air, against the widest time. Otherwise the numbers stand alone. */
      var gap = 1;
      for (var c = 1; c < st.cs.length; c++) gap = Math.min(gap, st.cs[c] - st.cs[c - 1]);
      var spans = $$('.dim__slots li span', st.el), widest = 0;
      st.el.className = st.el.className.replace(/(^|\s)dim--short(?=\s|$)/g, '');
      for (var sp = 0; sp < spans.length; sp++) widest = Math.max(widest, spans[sp].offsetWidth);
      if (widest === 0 || widest > gap * st.W - 10) st.el.className += ' dim--short';
      var r0 = st.rule ? st.rule.offsetLeft : 0;
      st.ranges = [];
      for (var i = 0; i < st.lines.length; i++) {
        var a = (r0 + st.lines[i].offsetLeft) / st.W;
        st.ranges.push([a, Math.max(0.001, st.lines[i].offsetWidth / st.W)]);
      }
      st.totalAt = st.total ? (r0 + st.total.offsetLeft) / st.W : 0.5;
    }
    function apply(st, p) {
      p = clamp(p);
      if (st.p >= 0 && Math.abs(p - st.p) <= 0.002 && !((p === 0 || p === 1) && p !== st.p)) return;
      st.p = p;
      if (!st.W || !st.ranges) measure(st);
      if (st.scan) {
        st.scan.style.opacity = p > 0 ? String(Math.min(1, (1 - p) * 20).toFixed(3)) : '0';
        st.scan.style.transform = 'translate3d(' + (p * st.W).toFixed(1) + 'px,0,0)';
      }
      for (var i = 0; i < st.lis.length; i++) {
        var o = clamp((p - st.cs[i]) / 0.035);
        st.lis[i].style.opacity = o.toFixed(3);
        st.lis[i].style.transform = 'translate(-50%,' + ((1 - o) * 4).toFixed(1) + 'px)';
      }
      for (var l = 0; l < st.lines.length; l++) {
        var g = st.ranges[l];
        st.lines[l].style.transform = 'scaleX(' + clamp((p - g[0]) / g[1]).toFixed(3) + ')';
      }
      if (st.total) st.total.style.opacity = clamp((p - st.totalAt) / 0.06).toFixed(3);
      if (st.rule) st.rule.style.opacity = p > 0 ? '1' : '0';
    }
    function clear(st) {
      st.p = -1;
      var els = st.lis.concat(st.lines, [st.total, st.rule, st.scan]);
      for (var i = 0; i < els.length; i++) if (els[i]) { els[i].style.opacity = ''; els[i].style.transform = ''; }
    }
    /* the merchant's own times: copy them from the Formulas timeline when it has all six */
    function syncTimes() {
      var times = $$('#formulas .tl__stop .tl__time');
      if (times.length < 6) return;
      for (var d = 0; d < all.length; d++) {
        var spans = $$('.dim__slots li span', all[d].el);
        for (var i = 0; i < spans.length && i < 6; i++) {
          var t = (times[i].textContent || '').replace(/^\s+|\s+$/g, '');
          if (spans[i].textContent !== t) spans[i].textContent = t;
        }
      }
    }
    /* the tick under the formula for the visitor's current hour is lime; the hours are the
       merchant's, read from the schedule rail's data-hours */
    var claimed = false, claimedAt = -1;
    function markNow() {
      if (claimed) { markAt(claimedAt); return; }
      var rows = $$('[data-hours]'), h = new Date().getHours(), at = -1;
      for (var i = 0; i < rows.length && i < 6; i++) {
        var hs = (rows[i].getAttribute('data-hours') || '').split(',');
        for (var k = 0; k < hs.length; k++) if (parseInt(hs[k], 10) === h) at = i;
      }
      markAt(at);
    }
    function markAt(at) {
      for (var d = 0; d < all.length; d++) {
        for (var j = 0; j < all[d].lis.length; j++) {
          var li = all[d].lis[j], want = j === at, has = /(^|\s)is-now(\s|$)/.test(li.className);
          if (want && !has) li.className += ' is-now';
          else if (!want && has) li.className = li.className.replace(/(^|\s)is-now(?=\s|$)/g, '');
        }
      }
    }
    function pinned(st) { return !!closest(st.el, '.stage.is-pinned'); }
    function frameLoose() {
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      for (var i = 0; i < live.length; i++) {
        var st = live[i];
        if (pinned(st)) continue;
        var top = st.el.getBoundingClientRect().top;
        apply(st, (vh - top) / (vh * 0.15));   /* drawn by the time the rule is at 85% of the screen */
      }
    }
    function init() {
      all = $$('[data-dim]').map(state);
      if (!all.length) return;
      syncTimes();
      markNow();
      if (reduce) return;
      if (io) io.disconnect();
      if ('IntersectionObserver' in window) {
        live = [];
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var st = en.target._dim, at = live.indexOf(st);
            if (en.isIntersecting) { if (at < 0) live.push(st); }
            else {
              if (at > -1) live.splice(at, 1);
              if (!pinned(st)) apply(st, en.boundingClientRect.top < 0 ? 1 : 0);
            }
          });
          Scroll.request();
        });
        all.forEach(function (st) { io.observe(st.el); });
      } else {
        live = all.slice();
      }
      Scroll.on('dim', frameLoose);
      Scroll.request();
    }
    on(window, 'resize', function () { for (var i = 0; i < all.length; i++) { all[i].W = 0; all[i].ranges = null; all[i].p = -1; } });
    window.setInterval(markNow, 60000);
    init();
    on(doc, 'shopify:section:load', function () { window.setTimeout(init, 90); });
    return {
      stage: function (slide, t) {
        if (reduce) return;
        if (slide._dimEl === undefined) slide._dimEl = $('[data-dim]', slide);
        if (!slide._dimEl) return;
        apply(state(slide._dimEl), t < -0.25 ? 1 + (t + 0.25) / 0.4 : 1);   /* complete before the slide is current */
      },
      reset: function (slide) {
        var d = slide._dimEl === undefined ? $('[data-dim]', slide) : slide._dimEl;
        if (d) clear(state(d));
        Scroll.request();
      },
      /* schedule() owns the clock once it has parsed the merchant's times: it hands in the index of
         the formula whose window holds the local time (-1 for none) */
      mark: function (at) { claimed = true; claimedAt = at; markAt(at); },
      /* the labels' times changed (the planner): write them and re-measure what fits */
      times: function (list) {
        for (var d = 0; d < all.length; d++) {
          var spans = $$('.dim__slots li span', all[d].el);
          for (var i = 0; i < spans.length && i < list.length; i++) if (spans[i].textContent !== list[i]) spans[i].textContent = list[i];
        }
      },
      remeasure: function () { for (var i = 0; i < all.length; i++) { all[i].W = 0; all[i].ranges = null; all[i].p = -1; } Scroll.request(); }
    };
  })();

  /* ---------- Marquee: duplicate the group so the loop is seamless ---------- */
  /* ---------- Marquee ----------
     Driven by JS rather than a CSS keyframe. The old version varied speed by writing
     animation-duration on every scroll frame, and each rewrite restarted the animation
     from its first keyframe, which read as a jump. Advancing the transform ourselves
     lets the speed change continuously with nothing to restart. Without JS the CSS
     keyframe in fbd.css still runs, so the belt never sits dead. */
  (function marquee() {
    var tracks = $$('[data-marquee]');
    if (!tracks.length) return;

    /* enough copies that the belt covers the viewport twice over, whatever the text */
    tracks.forEach(function (track) {
      var group = $('.marquee__group', track);
      if (!group) return;
      var one = group.offsetWidth || 0;
      var need = one > 0 ? Math.ceil((window.innerWidth * 2) / one) : 1;
      if (need < 1) need = 1;
      for (var c = 0; c < need; c++) track.appendChild(group.cloneNode(true));
      track.className += ' is-ready';
    });

    /* wantsMotion is declared further down the file, so it is still undefined here;
       ask the media query directly rather than depending on declaration order. */
    var moves = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!moves || !('requestAnimationFrame' in window)) return;

    var belts = [];
    tracks.forEach(function (track) {
      var group = $('.marquee__group', track);
      if (!group) return;
      track.style.animation = 'none';   /* JS owns the transform from here on */
      var belt = { track: track, group: group, w: 0, x: 0, live: true, held: false };
      /* the belt is real copy: let people stop it to read it */
      on(track, 'mouseenter', function () { belt.held = true; });
      on(track, 'mouseleave', function () { belt.held = false; });
      belts.push(belt);
    });
    if (!belts.length) return;

    function measure() {
      for (var i = 0; i < belts.length; i++) {
        var w = belts[i].group.offsetWidth;
        if (w > 0) {
          /* hold the visual position when the width changes under us */
          if (belts[i].w > 0) belts[i].x = belts[i].x / belts[i].w * w;
          belts[i].w = w;
        }
      }
    }
    measure();
    on(window, 'resize', measure);
    on(window, 'load', measure);
    if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(measure);

    var BASE = 40;        /* px per second when the page is still */
    var boost = 0;        /* extra px per second the scroll has just handed it */
    var lastY = window.pageYOffset;
    var lastT = 0;
    var running = false;

    on(window, 'scroll', function () {
      var y = window.pageYOffset;
      boost += (y - lastY) * 5;
      lastY = y;
      if (boost > 1800) boost = 1800;
      if (boost < -1800) boost = -1800;
    });

    /* the loop only advances a belt that is actually on screen */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          for (var i = 0; i < belts.length; i++) {
            if (belts[i].track === en.target) belts[i].live = en.isIntersecting;
          }
          if (en.isIntersecting) start();
        });
      }, { rootMargin: '140px 0px' });
      for (var b0 = 0; b0 < belts.length; b0++) io.observe(belts[b0].track);
    }

    function tick(ts) {
      var dt = lastT ? Math.min(0.05, (ts - lastT) / 1000) : 0;
      lastT = ts;
      boost *= Math.pow(0.0016, dt);   /* bleeds away, so it eases back to resting speed */
      var v = BASE + boost;
      for (var i = 0; i < belts.length; i++) {
        var bl = belts[i];
        if (!bl.w || !bl.live || bl.held) continue;
        bl.x = (((bl.x + v * dt) % bl.w) + bl.w) % bl.w;   /* wraps in both directions */
        bl.track.style.transform = 'translate3d(' + (-bl.x).toFixed(2) + 'px,0,0)';
      }
      if (anyLive()) window.requestAnimationFrame(tick);
      else running = false;
    }
    function anyLive() {
      for (var i = 0; i < belts.length; i++) if (belts[i].live) return true;
      return false;
    }
    function start() {
      if (running) return;
      running = true; lastT = 0;
      window.requestAnimationFrame(tick);
    }
    start();
  })();


  /* ---------- Scroll stage: pin the hero and cycle the product slides ----------
     Enhancement only. It switches on when the browser can do it well; otherwise
     the slides stay stacked and the page reads exactly as it would without JS. */
  var stageUnbind = null;   /* the previous build's listeners; a section reload must not stack them */
  function buildStage() {
    if (stageUnbind) { stageUnbind(); stageUnbind = null; }
    var el = $('[data-stage]');

    /* In Shopify each section is its own sibling <div id="shopify-section-...">, so the
       stage container cannot be written in Liquid. Sections opt in with data-stage-slide
       and are collected here; the resulting DOM matches the static preview exactly. */
    if (!el) {
      var marked = $$('[data-stage-slide]');
      if (marked.length < 2) return;
      var first = marked[0];
      var host = first.parentNode;
      while (host && host.parentNode && host.parentNode.nodeName !== 'MAIN' && host.parentNode !== doc.body) host = host.parentNode;
      if (!host || !host.parentNode) return;
      el = doc.createElement('section');
      el.className = 'stage';
      el.setAttribute('data-stage', '');
      var pin = doc.createElement('div');
      pin.className = 'stage__pin';
      el.appendChild(pin);
      host.parentNode.insertBefore(el, host);
      for (var m = 0; m < marked.length; m++) {
        var sec = marked[m];
        var wrapper = sec.parentNode;
        /* move the whole shopify-section wrapper so section settings keep working */
        var node = (wrapper && wrapper.id && wrapper.id.indexOf('shopify-section') === 0) ? wrapper : sec;
        sec.setAttribute('data-slide', String(m));
        sec.className += ' stage__slide';
        pin.appendChild(node);
      }
    }

    var slides = $$('[data-slide]', el);
    if (slides.length < 2) return;

    var supportsSticky = false;
    try {
      var probe = doc.createElement('div');
      probe.style.position = 'sticky';
      supportsSticky = probe.style.position.indexOf('sticky') > -1;
    } catch (e) { supportsSticky = false; }

    /* where you are in the stage is shown by the header scale (scrollSpy), not by dots */
    var pinned = false, current = -1, ticking = false;

    function canPin() {
      return supportsSticky
        && window.innerWidth >= 900
        && window.innerHeight >= 560
        && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function setCurrent(i) {
      if (i === current) return;
      current = i;
      for (var s = 0; s < slides.length; s++) {
        var cls = slides[s].className.replace(/\s*is-(current|past)/g, '');
        if (s === i) cls += ' is-current';
        else if (s < i) cls += ' is-past';
        slides[s].className = cls;
      }
    }

    function enable() {
      if (pinned) return;
      pinned = true;
      el.className += ' is-pinned';
      /* one viewport of scroll per slide, plus one to read the last one */
      el.style.height = ((slides.length + 1) * 100) + 'vh';
      current = -1;
      setCurrent(0);
    }
    function disable() {
      if (!pinned) return;
      pinned = false;
      el.className = el.className.replace(' is-pinned', '');
      el.style.height = '';
      clearMotion();
      for (var s = 0; s < slides.length; s++) {
        slides[s].className = slides[s].className.replace(/\s*is-(current|past)/g, '');
        slides[s].removeAttribute('aria-hidden');
      }
      current = -1;
    }

    /* Scroll-linked, not state-switched. Every slide's opacity and offset are a
       continuous function of scroll position, so the sequence flows under the
       finger instead of jumping when a threshold is crossed. */
    var moves = [], depths = [];
    for (var mi = 0; mi < slides.length; mi++) {
      moves.push($('.stage__move', slides[mi]));
      depths.push($$('[data-stage-depth]', slides[mi]));
    }

    function clearMotion() {
      for (var s = 0; s < slides.length; s++) {
        slides[s].style.opacity = '';
        slides[s].style.visibility = '';
        slides[s].removeAttribute('aria-hidden');
        slides[s].style.zIndex = '';
        slides[s].style.pointerEvents = '';
        if (moves[s]) moves[s].style.transform = '';
        for (var d = 0; d < depths[s].length; d++) depths[s][d].style.transform = '';
        if (Dim) Dim.reset(slides[s]);
      }
    }

    function frame() {
      ticking = false;
      if (!pinned) return;
      var travel = el.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var r = el.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / travel));

      /* one unit of pos == one viewport of scroll. The half-slide offset holds the
         first and last slide steady at the ends instead of fading them immediately. */
      var pos = p * slides.length - 0.5;
      if (pos < 0) pos = 0;
      if (pos > slides.length - 1) pos = slides.length - 1;

      for (var s = 0; s < slides.length; s++) {
        var t = pos - s;                 /* <0 still ahead, 0 present, >0 already passed */
        var at = t < 0 ? -t : t;
        var sl = slides[s];

        if (at >= 1) {
          if (sl.style.visibility !== 'hidden') {
            sl.style.visibility = 'hidden';
            sl.style.opacity = '0';
            sl.style.pointerEvents = 'none';
            sl.setAttribute('aria-hidden', 'true');   /* hidden from AT only once it is unfocusable */
          }
          continue;
        }

        var x = at / 0.72;
        if (x > 1) x = 1;
        var o = 1 - x * x * (3 - 2 * x);   /* smoothstep: still position-driven, just eased at the ends */
        sl.style.visibility = 'visible';
        if (sl.getAttribute('aria-hidden') !== 'false') sl.setAttribute('aria-hidden', 'false');
        sl.style.opacity = o.toFixed(3);
        sl.style.zIndex = String(10 - Math.round(at * 9));
        sl.style.pointerEvents = o > 0.5 ? 'auto' : 'none';

        if (moves[s]) {
          moves[s].style.transform =
            'translate3d(0,' + (-t * 7).toFixed(2) + 'vh,0) scale(' + (1 - at * 0.045).toFixed(4) + ')';
        }
        var dl = depths[s];
        for (var d = 0; d < dl.length; d++) {
          var k = parseFloat(dl[d].getAttribute('data-stage-depth')) || 0;
          dl[d].style.transform = 'translate3d(0,' + (-t * k).toFixed(2) + 'vh,0)';
        }
        if (Dim) Dim.stage(sl, t);   /* specimen lines draw on arrival and stay drawn */

      }
      setCurrent(Math.max(0, Math.min(slides.length - 1, Math.round(pos))));
    }
    function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(frame); } }

    function sync() { if (canPin()) { enable(); frame(); } else { disable(); } }

    /* Inside the pinned stage every slide sits at the same place, so an anchor such as
       #liquid cannot be reached by the browser's own jump. Send it to that slide's slice
       of the stage's scroll range instead. */
    function scrollToSlide(i, smooth) {
      if (!pinned) { slides[i].scrollIntoView({ block: 'start' }); return; }
      var travel = el.offsetHeight - window.innerHeight;
      var top = el.offsetTop + (travel * (i + 0.35) / slides.length);
      if (smooth && wantsSmooth() && 'scrollBehavior' in doc.documentElement.style) window.scrollTo({ top: top, behavior: 'smooth' });
      else window.scrollTo(0, top);
    }
    function wantsSmooth() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function slideIndexForId(id) {
      for (var i = 0; i < slides.length; i++) if (slides[i].id === id) return i;
      return -1;
    }
    var onAnchor = function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = href.slice(href.indexOf('#') + 1);
      if (!hash) return;
      var i = slideIndexForId(hash);
      if (i < 0) return;
      e.preventDefault();
      scrollToSlide(i, true);
      if (history.replaceState) history.replaceState(null, '', '#' + hash);
    };
    on(doc, 'click', onAnchor);
    /* a deep link that arrives with the hash already set: wait for images to settle so
       the stage has its final height, then land on the right slide */
    if (window.location.hash) {
      var deep = slideIndexForId(window.location.hash.slice(1));
      if (deep > -1) {
        var land = function () { window.setTimeout(function () { sync(); scrollToSlide(deep, false); frame(); }, 220); };
        if (doc.readyState === 'complete') land();
        else on(window, 'load', land);
      }
    }

    /* the address bar or a back/forward step can change the hash without a reload */
    var onHash = function () {
      var i = slideIndexForId(window.location.hash.slice(1));
      if (i > -1) scrollToSlide(i, true);
    };
    on(window, 'hashchange', onHash);

    on(window, 'scroll', onScroll);
    on(window, 'resize', sync);
    stageUnbind = function () {
      doc.removeEventListener('click', onAnchor, false);
      window.removeEventListener('hashchange', onHash, false);
      window.removeEventListener('scroll', onScroll, false);
      window.removeEventListener('resize', sync, false);
    };
    sync();
  }
  buildStage();
  /* the Shopify theme editor re-renders sections; rebuild the stage when it does */
  on(doc, 'shopify:section:load', function () { window.setTimeout(buildStage, 60); });


  /* ================= Interaction layer =================
     Every effect below asks first whether the visitor has a real pointer and wants
     motion. Phones, touch laptops and reduced-motion visitors skip all of it. */
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var wantsMotion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);


  /* ---------- The range deck ----------
     One list, one viewer. Choosing a product swaps the panel; the list price stays
     struck through beside every outlet price. A pointer chooses on hover, because
     reading is faster than clicking; a phone taps; arrow keys walk the list. With
     JavaScript off every panel is already in the page, stacked. */
  /* Prices as arithmetic (fbd.css section 52). The authored "25% below list" becomes the sum a
     visitor can check: "-25% · You save $24.95", from the form's own data-price and data-compare.
     Written once per line; a line whose product has no list price above its price is hidden. The
     Liquid renders .deck__save only when the merchant's save_line setting is set, so clearing that
     setting still switches the line off. Without JS the authored text stays. */
  (function saveLines() {
    $$('.deck__save').forEach(function (line) {
      var form = closest(line, 'form[data-add-to-cart]');
      if (!form) { var box = closest(line, '.buybox'); form = box ? $('form[data-add-to-cart]', box) : null; }
      if (!form) return;
      var price = parseInt(form.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(form.getAttribute('data-compare'), 10) || 0;
      if (!(compare > price) || !price) { line.hidden = true; return; }
      var keep = compare - price;
      line.textContent = '\u2212' + Math.round(keep / compare * 100) + '% \u00b7 You save ' + money(keep);
    });
  })();

  (function deck() {
    var decks = $$('[data-deck]');
    if (!decks.length) return;
    decks.forEach(function (deck) {
      var tabs = $$('[data-deck-tab]', deck);
      var panels = $$('[data-deck-panel]', deck);
      if (tabs.length < 2 || !panels.length) return;
      var current = null;
      /* the film behind the product, under the same gate as the opener's: motion welcome,
         data saving off, not on 2G, so the phone and the desktop get the same deck. Sources
         are attached only once a product has been on show for a moment, so sweeping the
         pointer down the list does not start a download for every row it crosses. */
      var mq = window.matchMedia;
      var conn = navigator.connection || {};
      var filmOk = !!mq && wantsMotion && !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || '');
      function playFilm(panel) {
        var wrap = $('[data-deck-film]', panel);
        var vid = wrap && $('video', wrap);
        if (!vid) return;
        if (!filmOk) return;
        if (!vid.firstChild) {
          var webm = vid.getAttribute('data-webm'), mp4 = vid.getAttribute('data-mp4');
          if (webm) { var a = doc.createElement('source'); a.type = 'video/webm'; a.src = webm; vid.appendChild(a); }
          if (mp4)  { var b = doc.createElement('source'); b.type = 'video/mp4';  b.src = mp4;  vid.appendChild(b); }
          on(vid, 'playing', function () { if (wrap.className.indexOf('is-playing') < 0) wrap.className += ' is-playing'; });
          on(vid, 'error', function () { wrap.className = wrap.className.replace(' is-playing', ''); }, true);
          vid.load();
        }
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      }
      function stopFilm(panel) {
        var vid = $('[data-deck-film] video', panel);
        if (vid && !vid.paused) vid.pause();
      }
      var dwell = 0;
      function tabIndex(k) {
        for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('data-deck-tab') === k) return i + 1;
        return 0;
      }
      function show(key, fromUser) {
        if (key === current) return;
        var prevIndex = current === null ? 0 : tabIndex(current);
        current = key;
        window.clearTimeout(dwell);
        for (var i = 0; i < tabs.length; i++) {
          var isOn = tabs[i].getAttribute('data-deck-tab') === key;
          tabs[i].setAttribute('aria-selected', isOn ? 'true' : 'false');
          tabs[i].setAttribute('tabindex', isOn ? '0' : '-1');
          /* on a phone the list scrolls sideways: keep the chosen tab in view */
          if (isOn && fromUser && window.innerWidth < 900 && tabs[i].scrollIntoView) {
            try { tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: wantsMotion ? 'smooth' : 'auto' }); } catch (e) {}
          }
        }
        for (var p = 0; p < panels.length; p++) {
          var onp = panels[p].getAttribute('data-deck-panel') === key;
          panels[p].hidden = !onp;
          /* a product a visitor opens gets its list price struck left to right (section 52). The
             class comes off on animationend or after 700ms, whichever is first, so reduced motion
             (where the animation never runs) cannot leave it stuck. */
          if (onp && fromUser && $('s.was', panels[p])) {
            (function (panel) {
              window.clearTimeout(panel._arrive);
              panel.className = panel.className.replace(/(^|\s)is-arriving(?=\s|$)/g, '');
              void panel.offsetWidth;
              panel.className += ' is-arriving';
              var done = function () { window.clearTimeout(panel._arrive); panel.className = panel.className.replace(/(^|\s)is-arriving(?=\s|$)/g, ''); };
              panel._arrive = window.setTimeout(done, 700);
              if (!panel._arriveBound) { panel._arriveBound = true; on(panel, 'animationend', function (ev) { if (ev.animationName === 'fbd-strike') done(); }); }
            })(panels[p]);
          }
          if (onp) { (function (panel) { dwell = window.setTimeout(function () { if (!panel.hidden) playFilm(panel); }, 420); })(panels[p]); }
          else stopFilm(panels[p]);
          /* the counter settles from the last product's number to this one's (about 280ms);
             the total is read from the authored text, so the Liquid stays the source */
          if (onp && fromUser && prevIndex) {
            var counter = $('.deck__counter', panels[p]);
            var index = tabIndex(key);
            var tm = counter && /\/\s*(\d+)/.exec(counter.textContent || '');
            if (counter && tm && index) {
              (function (total) {
                Readout.roll(counter, prevIndex, index, function (v) { return pad2(v) + ' <em>/ ' + total + '</em>'; }, 280);
              })(tm[1]);
            }
          }
        }
      }
      /* the film stops while the deck is off screen */
      if (filmOk && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var p = 0; p < panels.length; p++) {
            if (panels[p].hidden) continue;
            if (entries[0].isIntersecting) playFilm(panels[p]); else stopFilm(panels[p]);
          }
        }, { rootMargin: '80px 0px' });
        io.observe(deck);
      }
      tabs.forEach(function (t) {
        var key = t.getAttribute('data-deck-tab');
        on(t, 'click', function () { show(key, true); });
        on(t, 'focus', function () { show(key, true); });
        on(t, 'mouseenter', function () { if (finePointer) show(key, true); });
      });
      on(deck, 'keydown', function (e) {
        var i = tabs.indexOf(doc.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); next.focus(); }
      });
      /* the page-wide form choice switches a deck that is showing capsules or liquid, never one on a
         companion the visitor picked; it does not scroll the list (fromUser false) */
      FormState.on(function (f) {
        if ((current === 'capsules' || current === 'liquid') && tabIndex(f)) show(f, false);
      });
      var first = null;
      for (var k = 0; k < tabs.length; k++) if (tabs[k].getAttribute('aria-selected') === 'true') first = tabs[k];
      show((first || tabs[0]).getAttribute('data-deck-tab'), false);
      /* a product page link back to #range?key lands on that product */
      var m = /[?&]item=([a-z-]+)/.exec(window.location.search || '');
      if (m) show(m[1], false);
    });
  })();

  /* ---------- Readouts (fbd.css sections 20 and 50) ----------
     Every reveal, the section-head rulers, the manifesto and the heritage figures are written
     from scroll position, never switched by a class and a timed transition.
     - A .reveal fades and rises 14px entirely inside the bottom 14% of the viewport, so nothing
       in the reading area is ever part-shown. reveal--d1/d2/d3 offset a sibling by 2% of vh.
     - A section head's eyebrow ruler (--rule) measures out as the head travels up to 55% of vh.
     - The manifesto's words brighten from .25 to 1 in reading order, as far as you have scrolled,
       and are all lit by the time its last line reaches 62% of vh.
     - A heritage figure under 1000 counts with the scroll (and back); the year is left alone.
     Positions are live rects of the few elements on screen (an IntersectionObserver keeps that
     list), so an opened FAQ or a switched panel can never leave a stale offset. The element's own
     rise is subtracted from its rect, so the readout never feeds back on itself. */
  (function readouts() {
    var io = null;
    function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
    function has(el, c) { return (' ' + el.className + ' ').indexOf(' ' + c + ' ') > -1; }
    function splitWords(el) {
      if (has(el, 'reveal-words')) return;
      /* keep inline <em> intact: split only the text between tags */
      el.innerHTML = el.innerHTML.replace(/>([^<]+)</g, function (m, text) {
        return '>' + text.split(/(\s+)/).map(function (w) {
          return /\S/.test(w) ? '<span class="word">' + w + '</span>' : w;
        }).join('') + '<';
      });
      el.className += ' reveal-words';
    }
    function init() {
      if (io) { io.disconnect(); io = null; }
      var reveals = $$('.reveal');
      var manifestos = $$('[data-reveal-words]');
      var stats = $$('[data-count-to]').filter(function (el) { return parseFloat(el.getAttribute('data-count-to')) < 1000; });
      var canRun = !prefersReduced() && ('IntersectionObserver' in window) && !!window.requestAnimationFrame;
      if (!canRun) {
        reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
        return;   /* words stay plain text, rulers full, figures as authored */
      }
      manifestos.forEach(splitWords);
      var items = [], live = [];
      reveals.forEach(function (el) {
        var m = /(^|\s)reveal--d(\d)(\s|$)/.exec(el.className);
        items.push({ kind: 'reveal', el: el, i: m ? parseInt(m[2], 10) : 0, p: -1, r: -1, off: 0, head: has(el, 'section-head') });
      });
      manifestos.forEach(function (el) { items.push({ kind: 'words', el: el, words: $$('.word', el), k: [] }); });
      stats.forEach(function (el) {
        items.push({ kind: 'stat', el: el, to: parseFloat(el.getAttribute('data-count-to')), suffix: el.getAttribute('data-count-suffix') || '', text: null });
      });
      function writeReveal(it, p, r) {
        if (it.p < 0 || Math.abs(p - it.p) > 0.01 || ((p === 0 || p === 1) && p !== it.p)) {
          it.p = p;
          it.off = (1 - p) * 14;
          it.el.style.opacity = p === 1 ? '1' : p.toFixed(3);
          it.el.style.transform = p === 1 ? 'none' : 'translate3d(0,' + it.off.toFixed(1) + 'px,0)';
        }
        if (it.head && (it.r < 0 || Math.abs(r - it.r) > 0.005 || ((r === 0 || r === 1) && r !== it.r))) {
          it.r = r;
          if (it.el.style.setProperty) it.el.style.setProperty('--rule', r.toFixed(3));
        }
      }
      function writeWords(it, k) {
        for (var n = 0; n < it.words.length; n++) {
          var o = Math.max(0.25, Math.min(1, k - n));
          o = Math.round(o * 20) / 20;
          if (it.k[n] !== o) { it.k[n] = o; it.words[n].style.opacity = o === 1 ? '1' : String(o); }
        }
      }
      function writeStat(it, p) {
        var text = Math.round(it.to * (1 - (1 - p) * (1 - p))) + it.suffix;
        if (it.text !== text) { it.text = text; it.el.textContent = text; }
      }
      function read(it, vh, rect) {
        if (it.kind === 'reveal') {
          var top = rect.top - it.off;
          writeReveal(it, clamp((vh - top - it.i * vh * 0.02) / (vh * 0.14)), clamp((vh - top) / (vh * 0.45)));
        } else if (it.kind === 'words') {
          var owner = it.el._readout;
          var t = rect.top - (owner ? owner.off : 0);
          writeWords(it, clamp((vh * 0.88 - t) / (rect.height + vh * 0.26)) * it.words.length);
        } else {
          /* final inside the bottom 12% of the screen, where the block is still fading in: a figure
             that states a product fact never rests on a wrong value in the reading area (v8 polish) */
          writeStat(it, clamp((vh - rect.top) / (vh * 0.12)));
        }
      }
      /* the manifesto is both a reveal and a readout: let the words see the block's rise */
      items.forEach(function (it) { if (it.kind === 'reveal') it.el._readout = it; });
      function settle(it, above) {
        if (it.kind === 'reveal') writeReveal(it, above ? 1 : 0, above ? 1 : 0);
        else if (it.kind === 'words') writeWords(it, above ? it.words.length : 0);
        else writeStat(it, above ? 1 : 0);
      }
      function frame() {
        var vh = window.innerHeight || doc.documentElement.clientHeight;
        for (var i = 0; i < live.length; i++) read(live[i], vh, live[i].el.getBoundingClientRect());
      }
      var byEl = [];
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var list = byEl[en.target._readoutIndex] || [];
          for (var j = 0; j < list.length; j++) {
            var it = list[j], at = live.indexOf(it);
            if (en.isIntersecting) { if (at < 0) live.push(it); }
            else { if (at > -1) live.splice(at, 1); settle(it, en.boundingClientRect.top < 0); }
          }
        });
        Scroll.request();
      }, { rootMargin: '0px' });
      var targets = [];
      items.forEach(function (it) {
        var idx = targets.indexOf(it.el);
        if (idx < 0) { idx = targets.length; targets.push(it.el); byEl[idx] = []; it.el._readoutIndex = idx; }
        byEl[idx].push(it);
      });
      targets.forEach(function (el) { io.observe(el); });
      Scroll.on('readouts', frame);
      Scroll.request();
    }
    init();
    on(doc, 'shopify:section:load', function () { window.setTimeout(init, 90); });
  })();


  /* ---------- The marquee speeds up and flips with the scroll ---------- */

  /* (v8 polish: timelineSwipe() is gone. A swipe along the card strip is a scroll, never a
     "next formula" command; tapping a card selects it.) */

  /* ---------- Scroll spy and the header position scale ----------
     A long one-pager with a pinned section in the middle gives no sense of place otherwise.
     The header's bottom rule becomes a graduated scale (fbd.css section 48): one tick per
     section in the navigation at that section's real position on the page, a lime fill
     that grows with scroll, and a needle at your position. The tick for the section you are
     in turns lime, as the nav link does. On phones, where the header has no links, it is the
     only "where am I" signal, which is why it replaced the stage dots, the Scroll hint and the
     top progress bar.
     Ticks are measured (load, resize, fonts, section reload, body resize), never per frame;
     the fill and the needle are written from scroll position on every frame of the bus. */
  (function scrollSpy() {
    var header = null, scale = null, fill = null, needle = null;
    var uniq = [], currentId = null, W = 0;

    function collect() {
      var links = $$('.nav a, .mobile-nav__links a');
      var byId = {}, list = [];
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href') || '';
        var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#') + 1) : '';
        if (!hash) continue;
        /* several links can point at the same section; group them */
        if (!byId.hasOwnProperty(hash)) {
          var el = doc.getElementById(hash);
          byId[hash] = el ? { id: hash, el: el, links: [], tick: null } : null;
          if (el) list.push(byId[hash]);
        }
        if (byId[hash]) byId[hash].links.push(links[i]);
      }
      return list;
    }

    function make(cls) { var n = doc.createElement('i'); n.className = cls; return n; }
    function build() {
      header = $('[data-header]');
      if (!header) { scale = null; return; }
      scale = $('.hscale', header);
      if (!scale) {
        scale = doc.createElement('div');
        scale.className = 'hscale';
        scale.setAttribute('aria-hidden', 'true');
        scale.appendChild(make('hscale__fill'));
        scale.appendChild(make('hscale__needle'));
        header.appendChild(scale);
      }
      fill = $('.hscale__fill', scale);
      needle = $('.hscale__needle', scale);
      var old = $$('.hscale__tick', scale);
      for (var k = 0; k < old.length; k++) scale.removeChild(old[k]);
      for (var u = 0; u < uniq.length; u++) {
        var t = make('hscale__tick');
        t.setAttribute('data-for', uniq[u].id);
        scale.insertBefore(t, needle);
        uniq[u].tick = t;
      }
    }

    /* where the page is when this section arrives. A pinned slide shares the stage's box, so it
       takes the same slice of the stage's scroll range that scrollToSlide() lands on. */
    function docY(el) {
      var stage = el.getAttribute('data-slide') !== null ? closest(el, '.stage.is-pinned') : null;
      if (stage) {
        var slides = $$('[data-slide]', stage);
        var i = slides.indexOf(el);
        var travel = stage.offsetHeight - window.innerHeight;
        if (i > -1 && travel > 0) return stage.getBoundingClientRect().top + window.pageYOffset + travel * (i + 0.35) / slides.length;
      }
      return el.getBoundingClientRect().top + window.pageYOffset;
    }
    function maxScroll() { return doc.documentElement.scrollHeight - window.innerHeight; }

    function measure() {
      if (!scale) return;
      W = scale.offsetWidth;
      var max = maxScroll();
      for (var u = 0; u < uniq.length; u++) {
        if (!uniq[u].tick) continue;
        var f = max > 0 ? Math.max(0, Math.min(1, docY(uniq[u].el) / max)) : 0;
        /* the negative margin keeps a tick at 100% inside the scale's clipped box */
        uniq[u].tick.style.left = (f * 100).toFixed(3) + '%';
        uniq[u].tick.style.marginLeft = (-f).toFixed(3) + 'px';
      }
      frameSpy(window.pageYOffset);
    }

    function mark(id) {
      if (id === currentId) return;
      currentId = id;
      for (var u = 0; u < uniq.length; u++) {
        var on_ = uniq[u].id === id;
        for (var n = 0; n < uniq[u].links.length; n++) {
          if (on_) uniq[u].links[n].setAttribute('aria-current', 'true');
          else uniq[u].links[n].removeAttribute('aria-current');
        }
        var t = uniq[u].tick;
        if (t) t.className = on_ ? 'hscale__tick is-on' : 'hscale__tick';
      }
    }
    function frameSpy(y) {
      if (typeof y !== 'number') y = window.pageYOffset;
      var line = window.innerHeight * 0.34;   /* the reading line, not the very top */
      var best = null, bestTop = -Infinity;
      for (var u = 0; u < uniq.length; u++) {
        var el = uniq[u].el;
        /* a pinned slide reports the stage's box, so ask whether it is the current one. Visibility
           alone is not enough: the slide that is fading out stays visible at opacity 0, and every
           pinned slide has the same top, so the first one (Capsules) kept winning. */
        if (el.getAttribute('data-slide') !== null && closest(el, '.stage.is-pinned') &&
            (' ' + el.className + ' ').indexOf(' is-current ') < 0) continue;
        var top = el.getBoundingClientRect().top;
        if (top <= line && top > bestTop) { bestTop = top; best = uniq[u].id; }
      }
      var max = scale ? maxScroll() : 0;
      mark(best);
      if (!scale || !fill || !needle) return;
      var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
      fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      needle.style.transform = 'translateX(' + (p * Math.max(0, W - 2)).toFixed(1) + 'px)';
    }

    function init() {
      uniq = collect();
      currentId = null;
      build();
      if (!scale && !uniq.length) return;
      measure();
    }
    init();
    Scroll.on('spy', frameSpy);

    var pending = 0;
    function soon() { window.clearTimeout(pending); pending = window.setTimeout(measure, 200); }
    on(window, 'load', measure);
    on(window, 'resize', measure);
    if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(measure);
    /* the Theme Editor re-renders sections; buildStage() rebuilds at 60ms, so re-collect after it */
    on(doc, 'shopify:section:load', function () { window.setTimeout(init, 120); });
    if (window.ResizeObserver) {
      new window.ResizeObserver(soon).observe(body);
    } else {
      /* stale ticks are only cosmetic: re-measure after the things that change the page's height */
      doc.addEventListener('toggle', soon, true);
      on(doc, 'click', function (e) {
        if (closest(e.target, '[data-deck], [data-timeline], [data-herbs], details')) soon();
      });
    }
  })();

  /* ---------- The opening: form toggle and film ----------
     One control moves three things — the headline's product wording, the six bottles on
     show, and the film behind them — so choosing a form is something you can see rather
     than a label you have to read. The <video> ships with no sources; they are attached
     only on a wide viewport, with motion welcome and data saving off, so a phone spends
     nothing on it. */
  (function opener() {
    var section = $('.opener');
    if (!section) return;
    var vid = $('[data-hero-video]');
    var wrap = $('[data-hero-video-wrap]');
    var picks = $$('[data-pick-form]');
    var shots = $$('[data-form-media]');
    var cta = $('[data-form-cta]');
    var mq = window.matchMedia;
    var wantsMove = !(mq && mq('(prefers-reduced-motion: reduce)').matches);
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData;
    var slow = /(^|-)2g$/.test(conn.effectiveType || '');   /* a phone on 2G is spared the film */
    var filmOk = !!mq && wantsMove && !saveData && !slow && vid && wrap;
    var current = null;
    var ctl = $('[data-film-toggle]');
    var held = false;                     /* the visitor pressed pause */
    function setCtl() {
      if (!ctl) return;
      ctl.hidden = false;
      ctl.setAttribute('aria-pressed', held ? 'true' : 'false');
      ctl.textContent = held ? 'Play film' : 'Pause film';
    }

    function show() {
      if (!wrap) return;
      wrap.className = wrap.className.replace(' is-switching', '');
      if (wrap.className.indexOf('is-playing') < 0) wrap.className += ' is-playing';
    }
    var pendingFilm = 0;
    function loadFilm(form) {
      if (!filmOk) return;
      var webm = vid.getAttribute('data-webm-' + form);
      var mp4 = vid.getAttribute('data-mp4-' + form);
      if (!webm && !mp4) return;
      function go() {
        while (vid.firstChild) vid.removeChild(vid.firstChild);
        if (webm) { var a = doc.createElement('source'); a.type = 'video/webm'; a.src = webm; vid.appendChild(a); }
        if (mp4)  { var b = doc.createElement('source'); b.type = 'video/mp4';  b.src = mp4;  vid.appendChild(b); }
        vid.load();
        if (held) { show(); return; }
        var p = vid.play();
        if (p && p.catch) p.catch(function () { show(); });
      }
      /* a film already showing dissolves out first; the new one fades in when it plays */
      if (wrap.className.indexOf('is-playing') > -1) {
        if (wrap.className.indexOf('is-switching') < 0) wrap.className += ' is-switching';
        window.clearTimeout(pendingFilm);
        pendingFilm = window.setTimeout(go, 460);
      } else {
        go();
      }
    }

    var onScreen = true, deferred = null;
    function set(form, remote) {
      if (form === current) return;
      current = form;
      section.setAttribute('data-form', form);
      for (var i = 0; i < picks.length; i++) {
        picks[i].setAttribute('aria-pressed', picks[i].getAttribute('data-pick-form') === form ? 'true' : 'false');
      }
      for (var s2 = 0; s2 < shots.length; s2++) {
        var off = shots[s2].getAttribute('data-form-media') !== form;
        shots[s2].hidden = false;                 /* the markup hides the second one for no-JS */
        shots[s2].className = shots[s2].className.replace(' is-off', '') + (off ? ' is-off' : '');
        shots[s2].setAttribute('aria-hidden', off ? 'true' : 'false');
      }
      if (cta) cta.setAttribute('href', '#' + form);
      /* a choice made further down the page does not start a download for a film nobody can see:
         it waits until the opening is back on screen */
      if (remote && !onScreen && filmOk) deferred = form;
      else { deferred = null; loadFilm(form); }
      FormState.set(form, 'opener');
    }
    FormState.on(function (f, src) { if (src !== 'opener') set(f, true); });

    /* choosing a form runs the deck's one-pixel scan once across the lineup box. The span is
       created once; restarting it is remove class, force a reflow, add class. No transform is
       put on .opener__product itself: the stage's frame() owns that. */
    var product = $('.opener__product', section);
    var scan = null;
    function runScan() {
      if (!product || prefersReduced()) return;
      if (!scan) {
        scan = doc.createElement('span');
        scan.className = 'tool__scan';
        scan.setAttribute('aria-hidden', 'true');
        product.appendChild(scan);
      }
      scan.className = 'tool__scan';
      void scan.offsetWidth;
      scan.className = 'tool__scan is-run';
    }
    picks.forEach(function (b) {
      on(b, 'click', function () {
        var form = b.getAttribute('data-pick-form');
        if (form === current) return;
        set(form);
        runScan();
      });
    });

    if (vid) { on(vid, 'playing', show); on(vid, 'loadeddata', show); }
    if (vid && ctl && filmOk) {
      on(vid, 'playing', setCtl);
      on(ctl, 'click', function () {
        held = !held;
        if (held) vid.pause(); else { var r = vid.play(); if (r && r.catch) r.catch(function () {}); }
        setCtl();
      });
    }
    set(section.getAttribute('data-form') || 'capsules');

    /* stop the decoder while the opening is off screen */
    if (filmOk && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen && deferred) { var d = deferred; deferred = null; loadFilm(d); return; }
        if (onScreen) { if (!held) { var q = vid.play(); if (q && q.catch) q.catch(function () {}); } }
        else { vid.pause(); }
      }, { rootMargin: '100px 0px' });
      io.observe(wrap);
    }
  })();

  /* ---------- The live schedule (fbd.css section 51) ----------
     The rail reads the visitor's clock and the Formulas section lets them set their morning.
     - Single source of truth: the six .tl__time texts the merchant typed. parseTime() accepts
       "7:00 AM", "1 to 2 PM" and "11:30 AM to 12:30 PM". If any of the six fails, the planner
       stays hidden and nothing is retimed; the clock falls back to the rail's data-hours.
     - A formula's clock window runs from its start to the next formula's start (the last one to
       its own end), so "1 to 2 PM" is the 1-3 PM column: at 1:42 PM it is 35% filled.
     - "My day starts at" moves the start in 30 minute steps. Every time on the page settles
       together (timeline cards, panel kickers, the opener rail, the specimen labels) and the
       ruler's windows slide in lockstep, all written from one Readout.roll. It wraps past
       midnight. The start is remembered (localStorage 'fbd-start'); the time is read locally
       and never sent anywhere.
     - The clock is re-read on the minute, and not at all while the tab is hidden. */
  (function schedule() {
    var tl = $('[data-timeline]');
    var rail = $('.opener .rail') || $('.rail');
    var railLis = rail ? $$('li[data-hours]', rail) : [];
    var stops = tl ? $$('.tl__stop', tl).filter(function (s) { return /^f\d+$/.test(s.getAttribute('data-stop') || ''); }) : [];
    var charStop = tl ? $('.tl__stop[data-stop="charcoal"]', tl) : null;
    if (!stops.length && !railLis.length) return;

    function trim(t) { return (t || '').replace(/ /g, ' ').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' '); }
    function mod(v) { return ((v % 1440) + 1440) % 1440; }
    function to24(h, m, mer) {
      h = parseInt(h, 10); m = m ? parseInt(m, 10) : 0;
      if (!(h >= 1 && h <= 12) || !(m >= 0 && m < 60)) return null;
      return (h % 12 + (/p/i.test(mer) ? 12 : 0)) * 60 + m;
    }
    function parseTime(str) {
      var t = trim(str).replace(/\s*[–—-]\s*/g, ' to ').replace(/\./g, '');
      var a = /^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i.exec(t);
      if (a) { var s0 = to24(a[1], a[2], a[3]); return s0 === null ? null : { start: s0, end: null }; }
      var b = /^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?\s*to\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i.exec(t);
      if (!b) return null;
      var e = to24(b[4], b[5], b[6]), s = to24(b[1], b[2], b[3] || b[6]);
      if (s === null || e === null) return null;
      if (!b[3] && s > e && s >= 720) s -= 720;    /* "11 to 1 PM" is 11 AM */
      if (e <= s) return null;
      return { start: s, end: e };
    }
    function hm(v) {
      v = mod(v);
      var h = Math.floor(v / 60), m = v % 60;
      return { h: h % 12 === 0 ? 12 : h % 12, m: m, mer: h < 12 ? 'AM' : 'PM' };
    }
    function clockText(v) { var a = hm(v); return a.h + ':' + pad2(a.m) + ' ' + a.mer; }
    function fmt(start, end) {
      if (end === null) return clockText(start);
      var a = hm(start), b = hm(end);
      if (a.mer === b.mer) {
        if (a.m === 0 && b.m === 0) return a.h + ' to ' + b.h + ' ' + b.mer;
        return a.h + ':' + pad2(a.m) + ' to ' + b.h + ':' + pad2(b.m) + ' ' + b.mer;
      }
      return clockText(start) + ' to ' + clockText(end);
    }
    function minutesText(n) { return n < 60 ? n + ' min' : Math.floor(n / 60) + ' h' + (n % 60 ? ' ' + (n % 60) + ' min' : ''); }

    /* ---- what the merchant wrote ---- */
    var timeEls = stops.map(function (s) { return $('.tl__time', s); });
    var source = timeEls.length === 6 ? timeEls : $$('.rail__time', rail || doc);
    var base = [], ok = source.length === 6;
    for (var i = 0; ok && i < 6; i++) {
      var w = parseTime(source[i] && source[i].textContent);
      if (!w || (i && w.start <= base[i - 1].start)) ok = false; else base.push(w);
    }
    var lastEnd = ok ? (base[5].end !== null ? base[5].end : base[5].start + 60) : 0;
    if (ok && lastEnd > 1440) ok = false;

    var kickers = [], railTimes = [], hoursOrig = [];
    if (ok) {
      for (var k = 0; k < 6; k++) {
        var panel = tl ? $('[data-panel="' + stops[k].getAttribute('data-stop') + '"]', tl) : null;
        var kick = panel ? $('.tl__kicker .mono', panel) : null;
        var kt = kick ? kick.textContent : '';
        var dot = kt.lastIndexOf('·');
        kickers.push(kick && dot > -1 ? { el: kick, prefix: kt.slice(0, dot + 1) + ' ' } : null);
      }
    }
    railLis.forEach(function (li, n) {
      railTimes[n] = $('.rail__time', li);
      hoursOrig[n] = (li.getAttribute('data-hours') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x >= 0; });
    });

    var planner = tl ? $('[data-planner]', closest(tl, 'section') || doc) : null;
    var out = planner ? $('[data-plan-out]', planner) : null;
    var nowLine = planner ? $('[data-plan-now]', planner) : null;
    var tonight = planner ? (planner.getAttribute('data-plan-tonight') || '') : '';

    var start = ok ? base[0].start : 0, shown = start;
    if (ok) {
      var saved = parseInt(storage('fbd-start'), 10);
      if (saved >= 0 && saved < 1440 && saved % 30 === 0) start = shown = saved;
    }

    /* ---- the ruler: a 24 hour scale with the six windows and a needle at the local time ---- */
    var line = tl ? $('.tl__line', tl) : null, wins = [], needle = null, rulerW = 0;
    if (ok && line) {
      line.className += ' is-ruler';
      line.innerHTML = '';
      ['6 AM', '12 PM', '6 PM'].forEach(function (label, n) {
        var b = doc.createElement('b');
        b.className = 'tl__hr';
        b.style.left = ((n + 1) * 25) + '%';
        b.textContent = label;
        line.appendChild(b);
      });
      for (var q = 0; q < 6; q++) {
        var span = (q < 5 ? (base[q].end !== null ? base[q].end : base[q + 1].start) : lastEnd) - base[q].start;
        for (var twice = 0; twice < 2; twice++) {
          var wEl = doc.createElement('i');
          wEl.className = 'tl__win';
          var col = stops[q] && stops[q].style.getPropertyValue ? stops[q].style.getPropertyValue('--stop-color') : '';
          wEl.style.setProperty('--stop-color', col || 'var(--f' + (q + 1) + ')');
          wEl.style.width = (Math.max(45, span) / 1440 * 100).toFixed(3) + '%';
          line.appendChild(wEl);
          wins.push({ el: wEl, i: q, wrap: twice === 1 });
        }
      }
      needle = doc.createElement('i');
      needle.className = 'tl__needle';
      line.appendChild(needle);
    }

    /* ---- write every time on the page for a start of v minutes ---- */
    function apply(v) {
      if (!ok) return;
      shown = v;
      var off = v - base[0].start, texts = [];
      if (!rulerW && line) rulerW = line.offsetWidth;
      for (var n = 0; n < 6; n++) {
        var s = base[n].start + off, e = base[n].end !== null ? base[n].end + off : null;
        var text = fmt(s, e);
        texts.push(text);
        if (timeEls[n] && timeEls[n].textContent !== text) timeEls[n].textContent = text;
        if (kickers[n]) { var kt2 = kickers[n].prefix + text; if (kickers[n].el.textContent !== kt2) kickers[n].el.textContent = kt2; }
        if (railTimes[n] && railTimes[n].textContent !== text) railTimes[n].textContent = text;
        if (railLis[n] && hoursOrig[n] && hoursOrig[n].length) {
          railLis[n].setAttribute('data-hours', hoursOrig[n].map(function (h) { return Math.floor(mod(h * 60 + off) / 60); }).join(','));
        }
      }
      for (var wi = 0; wi < wins.length; wi++) {
        var x = mod(base[wins[wi].i].start + off) / 1440 * rulerW - (wins[wi].wrap ? rulerW : 0);
        wins[wi].el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      }
      if (Dim) Dim.times(texts);
      if (out) {
        var label = clockText(v);
        out.textContent = label;
        out.setAttribute('aria-valuenow', String(mod(v)));
        out.setAttribute('aria-valuetext', label);
      }
    }

    function set(target, instant) {
      if (!ok) return;
      target = mod(target);
      if (target === start && !instant) return;
      var from = shown, diff = mod(target - mod(from));
      if (diff > 720) diff -= 1440;                      /* the shortest way round midnight */
      start = target;
      storage('fbd-start', String(target));
      if (instant || !out) { apply(target); tick(); if (Dim) Dim.remeasure(); return; }
      Readout.roll(out, from, from + diff, function (v) { return clockText(v); }, 260, function (v, p) {
        apply(p < 1 ? Math.round(v / 5) * 5 : from + diff);
        if (p >= 1) { apply(target); tick(); if (Dim) Dim.remeasure(); }
      });
    }

    /* ---- the clock ---- */
    function clear(el, cls) { el.className = el.className.replace(new RegExp('(^|\\s)' + cls + '(?=\\s|$)', 'g'), ''); }
    function add(el, cls) { if ((' ' + el.className + ' ').indexOf(' ' + cls + ' ') < 0) el.className += ' ' + cls; }
    function tag(host, cls, text, before) {
      var t = $('.' + cls, host);
      if (!text) { if (t) t.parentNode.removeChild(t); return; }
      if (!t) {
        t = doc.createElement('span');
        t.className = cls;
        if (before && before.parentNode === host) host.insertBefore(t, before.nextSibling); else host.appendChild(t);
      }
      if (t.textContent !== text) t.textContent = text;
    }
    function tick() {
      var d = new Date(), m = d.getHours() * 60 + d.getMinutes();
      var at = -1, next = -1, frac = 0, after = false;
      if (ok) {
        var rel = mod(m - (start - base[0].start));
        if (rel < base[0].start) next = 0;
        else if (rel >= lastEnd) after = true;
        else {
          for (var n = 0; n < 6; n++) if (rel >= base[n].start) at = n;
          var to = at < 5 ? base[at + 1].start : lastEnd;
          frac = (rel - base[at].start) / (to - base[at].start);
        }
        if (nowLine) {
          var txt;
          var lead = 'If your day starts at ' + clockText(start) + ': ';
          if (at > -1) txt = at < 5 ? lead + 'Formula ' + (at + 2) + ' is next, at ' + clockText(base[at + 1].start + start - base[0].start) : lead + tonight;
          else if (next === 0) txt = lead + 'Formula 1 is in ' + minutesText(mod(start - m));
          else txt = tonight;
          if (nowLine.textContent !== txt) nowLine.textContent = txt;
        }
        if (needle) {
          needle.style.left = (m / 1440 * 100).toFixed(2) + '%';
          var rw = line ? line.offsetWidth : 0, hrs = line ? $$('.tl__hr', line) : [];
          for (var hi = 0; hi < hrs.length; hi++) {
            var near = rw > 0 && Math.abs(m / 1440 - (hi + 1) * 0.25) * rw < 14 + (hrs[hi].offsetWidth / 2);
            hrs[hi].style.visibility = near ? 'hidden' : '';
          }
        }
      } else {
        /* no parse: the rail's own hours still say which formula this hour belongs to */
        var hh = d.getHours();
        for (var r = 0; r < railLis.length; r++) {
          var hs = (railLis[r].getAttribute('data-hours') || '').split(',').map(function (x) { return parseInt(x, 10); });
          var ix = hs.indexOf(hh);
          if (ix > -1) { at = r; frac = (ix * 60 + d.getMinutes()) / (hs.length * 60); }
        }
      }
      railLis.forEach(function (li, n) {
        var link = $('.rail__link', li) || li;
        var isNow = n === at, isNext = n === next;
        if (isNow) add(li, 'is-now'); else clear(li, 'is-now');
        if (isNext) add(li, 'is-next'); else clear(li, 'is-next');
        tag(link, 'rail__tag', '', railTimes[n]);   /* quiet: the name brightens and the hairline fills; no chip */
        var fill = $('.rail__fill', li);
        if (isNow) {
          if (!fill) { fill = doc.createElement('i'); fill.className = 'rail__fill'; fill.setAttribute('aria-hidden', 'true'); li.appendChild(fill); }
          fill.style.transform = 'scaleX(' + Math.max(0, Math.min(1, frac)).toFixed(3) + ')';
        } else if (fill) li.removeChild(fill);
      });
      stops.forEach(function (s, n) { tag(s, 'tl__tag', n === at ? 'Now' : (n === next ? 'Next' : ''), $('.tl__time', s)); });
      if (charStop) tag(charStop, 'tl__tag', after ? 'Tonight' : '', $('.tl__time', charStop));
      if (Dim) Dim.mark(at);
      /* the opener rail always starts at Formula 1 (v8 polish): it is never scrolled for the visitor */
    }
    var tickTimer = 0, tickEvery = 0;
    function startClock() {
      stopClock();
      tick();
      var d = new Date();
      tickTimer = window.setTimeout(function () { tick(); tickEvery = window.setInterval(tick, 60000); }, (60 - d.getSeconds()) * 1000 - d.getMilliseconds() + 20);
    }
    function stopClock() { window.clearTimeout(tickTimer); window.clearInterval(tickEvery); }
    on(doc, 'visibilitychange', function () { if (doc.hidden) stopClock(); else startClock(); });

    /* ---- the planner's controls ---- */
    if (ok && planner) {
      planner.hidden = false;
      var head = closest(planner, '.section-head') || planner.parentNode;
      if (head && (' ' + head.className + ' ').indexOf(' has-planner ') < 0) head.className += ' has-planner';
      var held = false, holdDelay = 0, holdRepeat = 0;
      var stepBy = function (n) { set(start + n); };
      var release = function () { window.clearTimeout(holdDelay); window.clearInterval(holdRepeat); };
      $$('[data-plan-step]', planner).forEach(function (btn) {
        var n = parseInt(btn.getAttribute('data-plan-step'), 10) || 0;
        on(btn, 'click', function () { if (held) { held = false; return; } stepBy(n); });
        var down = function (e) {
          if (e.button !== undefined && e.button > 0) return;
          release(); held = false;
          holdDelay = window.setTimeout(function () { held = true; stepBy(n); holdRepeat = window.setInterval(function () { stepBy(n); }, 120); }, 400);
        };
        if (window.PointerEvent) {
          on(btn, 'pointerdown', down);
          on(btn, 'pointerup', release); on(btn, 'pointercancel', release); on(btn, 'pointerleave', release);
        } else {
          on(btn, 'touchstart', down); on(btn, 'touchend', release); on(btn, 'touchcancel', release);
          on(btn, 'mousedown', down); on(btn, 'mouseup', release); on(btn, 'mouseleave', release);
        }
        on(btn, 'contextmenu', function (e) { e.preventDefault(); });
      });
      if (out) on(out, 'keydown', function (e) {
        var k = e.key, to = null;
        if (k === 'ArrowUp' || k === 'Up' || k === 'ArrowRight') to = start + 30;
        else if (k === 'ArrowDown' || k === 'Down' || k === 'ArrowLeft') to = start - 30;
        else if (k === 'PageUp') to = start + 60;
        else if (k === 'PageDown') to = start - 60;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = 1410;
        if (to === null) return;
        e.preventDefault();
        set(to);
      });
    }

    /* ---- the rail's times open their formula ---- */
    on(doc, 'click', function (e) {
      var a = closest(e.target, '[data-rail-stop]');
      if (!a || !tl) return;
      var stop = $('[data-stop="' + a.getAttribute('data-rail-stop') + '"]', tl);
      var target = closest(tl, 'section') || tl;
      if (!stop) return;
      e.preventDefault();
      var smooth = !prefersReduced() && 'scrollBehavior' in doc.documentElement.style;
      try { target.scrollIntoView(smooth ? { behavior: 'smooth', block: 'start' } : true); } catch (err) { target.scrollIntoView(true); }
      stop.click();
    });

    apply(start);
    startClock();
    on(window, 'resize', function () { rulerW = 0; apply(shown); });
  })();

  /* ---------- The compare switch (fbd.css section 53) ----------
     [Capsules | Liquid] on the table: the chosen column locks on with the corner brackets and the
     other goes muted but stays readable; the lime scan runs down the table once; the chosen form's
     "Shop" button becomes the primary one. It sets the page-wide form, so the opener, the formula
     panels and the deck follow. On phones the rows restack (label above, both values side by side)
     instead of scrolling sideways, so both forms stay in view. Without JS the switch stays hidden
     and the table is exactly as authored. */
  (function compareSwitch() {
    var tables = $$('[data-compare-table]');
    if (!tables.length) return;
    tables.forEach(function (box) {
      var sec = closest(box, 'section') || doc;
      var sw = $('[data-compare-switch]', sec);
      var picks = sw ? $$('[data-compare-pick]', sw) : [];
      var ctas = $$('[data-form-cta-pick]', sec);
      var scan = $('.tool__scan', box);
      var table = $('table', box);
      /* grid rows on phones drop native table semantics in some engines: state them once */
      if (table && !table.getAttribute('role')) {
        table.setAttribute('role', 'table');
        $$('thead, tbody', table).forEach(function (g) { g.setAttribute('role', 'rowgroup'); });
        $$('tr', table).forEach(function (r) { r.setAttribute('role', 'row'); });
        $$('thead th', table).forEach(function (c) { c.setAttribute('role', 'columnheader'); });
        $$('tbody th', table).forEach(function (c) { c.setAttribute('role', 'rowheader'); });
        $$('td', table).forEach(function (c) { c.setAttribute('role', 'cell'); });
      }
      function paint(f, run) {
        box.setAttribute('data-show', f);
        picks.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-compare-pick') === f ? 'true' : 'false'); });
        ctas.forEach(function (a) {
          var mine = a.getAttribute('data-form-cta-pick') === f;
          a.className = a.className.replace(/(^|\s)btn--(primary|ghost)(?=\s|$)/g, '') + (mine ? ' btn--primary' : ' btn--ghost');
        });
        if (run && scan && !prefersReduced()) {
          scan.className = 'tool__scan';
          void scan.offsetWidth;
          scan.className = 'tool__scan is-run';
        }
      }
      if (sw) sw.hidden = false;
      picks.forEach(function (b) {
        on(b, 'click', function () { FormState.set(b.getAttribute('data-compare-pick'), 'compare'); });
      });
      FormState.on(function (f) { paint(f, true); });
      paint(FormState.get(), false);
    });
  })();

  /* ---------- The botanical explorer ----------
     One entry open at a time, per formula. The bodies are already in the DOM, so this
     only toggles which is shown; with JavaScript off the first entry of each formula
     stays open and the rest are simply further down the page. */
  (function herbs() {
    var groups = $$('[data-herbs]');
    if (!groups.length) return;
    groups.forEach(function (group) {
      var btns = $$('[data-herb]', group);
      function open(btn) {
        for (var i = 0; i < btns.length; i++) {
          var on = btns[i] === btn;
          btns[i].setAttribute('aria-expanded', on ? 'true' : 'false');
          var body = btns[i].parentNode.querySelector('[data-herb-body]');
          if (body) body.hidden = !on;
        }
      }
      /* left and right walk the set, home and end jump to the ends */
      on(group, 'keydown', function (e) {
        var i = btns.indexOf(doc.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = btns[(i + 1) % btns.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') next = btns[0];
        else if (e.key === 'End') next = btns[btns.length - 1];
        if (next) { e.preventDefault(); next.focus(); open(next); }
      });
      btns.forEach(function (b) {
        on(b, 'click', function () { open(b); });
        /* on a pointer device, reading is faster than clicking */
        on(b, 'mouseenter', function () {
          if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) open(b);
        });
        on(b, 'focus', function () { open(b); });
      });
    });
  })();

  /* ---------- The companion finders (v9: #recipes and #guide, fbd.css section 55) ----------
     A category filter, a search box and a limit over a list whose entries open in place. The
     entries are all in the DOM (details/summary), so without JavaScript every one is listed and
     opens; this only hides what does not match and what is past the limit, and reveals the
     controls. Nothing animates: the list changes in one frame. A link to #recipe-x or #guide-x
     (in the address bar, or a "See" link inside the guide) opens that entry where it stands. */
  (function finder() {
    var boxes = $$('[data-finder]');
    if (!boxes.length) return;
    function norm(t) { return String(t || '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, ''); }
    var api = [];
    boxes.forEach(function (box) {
      /* a phone shows fewer entries before "Show all" than a wide screen, where the control column is tall */
      function limitNow() {
        var wide = parseInt(box.getAttribute('data-finder-limit-wide'), 10);
        var base = parseInt(box.getAttribute('data-finder-limit'), 10) || 6;
        return (wide && window.innerWidth >= 900) ? wide : base;
      }
      var limit = limitNow();
      var q = $('[data-finder-q]', box);
      var cats = $$('[data-finder-cat]', box);
      var items = $$('[data-finder-item]', box);
      var groups = $$('[data-finder-group]', box);
      var count = $('[data-finder-count]', box);
      var shownEl = $('[data-finder-shown]', box);
      var totalEl = $('[data-finder-total]', box);
      var empty = $('[data-finder-empty]', box);
      var moreWrap = $('[data-finder-more-wrap]', box);
      var more = $('[data-finder-more]', box);
      var moreN = $('[data-finder-n]', box);
      var cat = 'all', expanded = false, lastQuery = '';
      var texts = items.map(function (it) { return ' ' + norm(it.getAttribute('data-finder-text') || it.textContent) + ' '; });

      function apply() {
        var words = norm(q ? q.value : '').split(' ').filter(function (w) { return !!w; });
        var matched = 0, shown = 0;
        items.forEach(function (it, i) {
          var ok = cat === 'all' || it.getAttribute('data-cat') === cat;
          for (var w = 0; ok && w < words.length; w++) {
            if (texts[i].indexOf(' ' + words[w]) < 0) ok = false;   /* word starts, so "pea" finds peach, not "papaya" */
          }
          var d = it.querySelector('details');
          var vis = ok && (expanded || matched < limit || (d && d.open));
          if (ok) matched++;
          if (vis) shown++;
          it.hidden = !vis;
        });
        groups.forEach(function (g) { g.hidden = !$$('[data-finder-item]', g).some(function (it) { return !it.hidden; }); });
        if (count) {
          count.hidden = false;
          if (shownEl) shownEl.textContent = pad2(shown);
          if (totalEl) totalEl.textContent = pad2(matched);
        }
        if (empty) empty.hidden = matched > 0;
        if (moreWrap) moreWrap.hidden = shown >= matched;
        if (moreN) moreN.textContent = String(matched);
      }
      function setCat(c) {
        cat = c; expanded = false;
        cats.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-finder-cat') === c ? 'true' : 'false'); });
        apply();
      }
      function reveal(it) {
        /* the entry may be filtered out or past the limit: clear both, then open it */
        if (it.hidden) {
          if (q && q.value) { q.value = ''; lastQuery = ''; }
          if (cat !== 'all' && it.getAttribute('data-cat') !== cat) setCat('all');
          expanded = true;
          apply();
        }
        var d = it.querySelector('details');
        if (d) d.open = true;
        var s = d ? d.querySelector('summary') : null;
        try { it.scrollIntoView({ block: 'start', behavior: prefersReduced() ? 'auto' : 'smooth' }); } catch (e) { it.scrollIntoView(true); }
        if (s && s.focus) { try { s.focus({ preventScroll: true }); } catch (e2) { s.focus(); } }
      }

      $$('[data-finder-tools]', box).forEach(function (el) { el.hidden = false; });
      cats.forEach(function (b) {
        on(b, 'click', function () {
          setCat(b.getAttribute('data-finder-cat'));
          if (window.innerWidth < 900 && b.scrollIntoView) {
            try { b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: prefersReduced() ? 'auto' : 'smooth' }); } catch (e) {}
          }
        });
      });
      if (q) {
        on(q, 'input', function () {
          var v = norm(q.value);
          if (v === lastQuery) return;
          lastQuery = v; expanded = false;
          apply();
        });
        on(q, 'keydown', function (e) {
          if (e.key === 'Escape' && q.value) { q.value = ''; lastQuery = ''; expanded = false; apply(); }
        });
      }
      if (more) {
        on(more, 'click', function () {
          var first = null;
          for (var i = 0; i < items.length; i++) { if (items[i].hidden) { first = i; break; } }
          expanded = true;
          apply();
          /* keep the reader's place: focus the first entry that was just shown */
          if (first !== null && !items[first].hidden) {
            var s = items[first].querySelector('summary');
            if (s && s.focus) { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }
          }
        });
      }
      /* "See Spasms" links inside the guide */
      on(box, 'click', function (e) {
        var a = closest(e.target, '[data-finder-goto]');
        if (!a) return;
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        var it = id ? doc.getElementById(id) : null;
        if (!it || !box.contains(it)) return;
        e.preventDefault();
        reveal(it);
        if (window.history && window.history.replaceState) { try { window.history.replaceState(null, '', '#' + id); } catch (err) {} }
      });
      on(window, 'resize', function () {
        var l = limitNow();
        if (l !== limit) { limit = l; if (!expanded) apply(); }
      });
      apply();
      api.push({ box: box, reveal: reveal });
    });

    function fromHash() {
      var id = (window.location.hash || '').slice(1);
      if (!/^(recipe|guide)-/.test(id)) return;
      var it = doc.getElementById(id);
      if (!it) return;
      for (var i = 0; i < api.length; i++) {
        if (api[i].box.contains(it)) {
          api[i].reveal(it);
          /* lazy images and the pinned stage above can still move the page while it lands: settle once */
          window.setTimeout(function () {
            var top = it.getBoundingClientRect().top;
            if (top < 0 || top > (window.innerHeight || 800) * 0.6) { try { it.scrollIntoView({ block: 'start' }); } catch (e) { it.scrollIntoView(true); } }
          }, 700);
          return;
        }
      }
    }
    on(window, 'hashchange', fromHash);
    if (window.location.hash) window.setTimeout(fromHash, 60);
  })();

  /* ---------- Footer year ---------- */
  $$('[data-year]').forEach(function (el) { el.textContent = String(new Date().getFullYear()); });

  window.FBD = { cart: Cart, toast: toast, form: FormState };
})();
